import React from 'react';

import { IComponentBaseProps } from '../../../../models/IComponentBaseProps.js';
import { ComponentBase, InjectedStyledComponent } from '../../../../shared/index.js';
import { DATE_PICKER_CATEGORY_KEY, DATE_PICKER_COMPONENT_KEY } from '../DatePicker.meta.js';
import { datePickerStyle } from '../styles/DatePicker.style.js';

interface IDialogProps extends IComponentBaseProps {
	innerRef?: typeof React.createRef;
	[key: string]: any;
}

export class Dialog extends ComponentBase<IDialogProps, any, any> {
	categoryKey = DATE_PICKER_CATEGORY_KEY;
	componentKey = DATE_PICKER_COMPONENT_KEY;

	render() {
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		const { className, innerRef, configuration, ...props } = this.props;
		return <div className={className} ref={innerRef} {...props}></div>;
	}
}

export default InjectedStyledComponent(
	Dialog,
	DATE_PICKER_CATEGORY_KEY,
	DATE_PICKER_COMPONENT_KEY,
	['dialogContent'],
	undefined,
	undefined,
	datePickerStyle.children?.dialogContent,
);
